export enum GraphicGrouping {
  none = 'none', hour = 'hour', day = 'day', week = 'week', month = 'month'
}
